import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable()
export class PropertyManagerPortalService {
  openPropertyManagerPortalMain() {
    const link = environment.propertyManagerPortalBaseUrl;
    window.open(link, '_self');
  }

  openPropertyManagerLineOfCredit() {
    const link = `${environment.propertyManagerPortalBaseUrl}/factoring`;
    window.open(link, '_self');
  }
}
